<template>
  <div>
    <!-- <section class="title-sec "> -->
      <div class="sec">
        <div class="row">
          <div class="col-md-12">
            <h3>{{message}}</h3>
            <!-- <p>Here are the high-impact projects you can support...</p> -->
          </div>
        </div>
      </div>
    <!-- </section> -->
  </div>
</template>

<script>
import config from '../config/app'
import userAPI from '../api/user'
import store from '../store'

export default {
  data () {
    return {
      user: store.getters.currentUser,
      message: null,
      host: config.host
    }
  },
  // components: {HeaderBusiness, FooterBusiness},
  created () {
    let code = this.$route.params.key
    const payload = {
      email_code: code
    }
    userAPI.updateFlagEmailVerf(payload).then((response) => {
      if (response.status === 'success') {
        this.message = 'Thank you for verifying your email! Two-Factor Authentication (2FA) is now enabled for your account.'
      } else {
        this.message = 'You already verified your email for 2FA.'
      }
      if (this.user) {
        store.dispatch('getCurrentUser')
      }
      // redirect to login page after 5 seconds with a message
      setTimeout(() => {
        this.$store.commit('setMessage', this.message)
        if (this.user) {
          this.$router.push({ name: 'family-dashbord' })
        } else {
          this.$router.push({ name: 'login' })
        }
      }, 5000)
    })
  }
}
</script>

<style scoped>
.sec {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full-screen height */
  background-color: #f4f4f4; /* Light background */
}

.message-box {
  background: white;
  padding: 100px 82px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-size: 30 !important;
  font-weight: 600;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailVerify.vue